import {Component, forwardRef, Input} from '@angular/core';
import {DictionariesService} from "../../../service";
import {IQrefVidOper} from "../../../models";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ViewDictionaryBase} from "../view-dictionary-base";

@Component({
  selector: 'app-dict-qref-vid-oper',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefVidOperViewComponent),
    multi: true
  }],
  template: `
    <div class="mb-3 pl-0 pr-0" [ngClass]="{ 'col-3': col3 }">
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         code="id"
                         name="type"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [formControl]="formControl"
                         [fieldsFromSearch]="['type','id']"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
          <b> {{ item.id }} </b>
          {{ item.type }}
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
          <b> {{ item.id }} </b>
          {{ item.type }}
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
    </div>
  `
})
export class QrefVidOperViewComponent extends ViewDictionaryBase<IQrefVidOper> {
  getDictionary = this.dictSrv.getQrefVidOperList();
  @Input() col3 = true
  constructor(private dictSrv: DictionariesService) {
    super();
  }
}
